/**
 * @typedef {'inline' | 'modal'} PRIVACY_COMPONENT_TYPE
 */

/**
 * A list of component types
 * @enum {PRIVACY_COMPONENT_TYPE}
 */
export enum PRIVACY_COMPONENT_TYPE {
  INLINE = 'inline',
  MODAL = 'modal',
}

/**
 * A translations map that contains bodega strings for error dialog.
 * @constant
 * @type {object}
 */
export const TRANSLATIONS_MAP = {
  INLINE_SET_ERROR_TEXT_SAVE: 'pc_cookie_error_text_settings_fails',
  INLINE_SET_ERROR_TITLE: 'pc_cookie_error_dialog_title',
  INLINE_SET_ERROR_ACTION_BUTTON_TITLE: 'pc_cookie_error_dialog_okay',
};

/**
 * The specific value of the project name in Bodega.
 */
export const PRIVACY_CONSENT_TRANSLATIONS = 'privacy-consent';

/**
 * A list of analytics details
 * @type {object}
 */
export const ANALYTICS_DETAILS = {
  experience: 'privacy-modal',
  pageName: 'nikecom>privacy modal',
  pageType: 'privacy modal',
};

/**
 * A list of analytics event names
 * @type {object}
 */
export const ANALYTICS_EVENTS = {
  PRIVACY_MODAL_VIEWED: {
    name: 'Privacy Modal Viewed',
    clickActivity: '',
  },
  PRIVACY_MODAL_ACCEPT_ALL_CLICKED: {
    name: 'Privacy Modal Accept All Clicked',
    clickActivity: 'dotcom:privacymodal:acceptall',
  },
  PRIVACY_MODAL_DECLINE_ALL_CLICKED: {
    name: 'Privacy Modal Decline All Clicked',
    clickActivity: 'dotcom:privacymodal:declineall',
  },
  PRIVACY_MODAL_ERROR_VIEWED: {
    name: 'Privacy Modal Error Viewed',
    clickActivity: '',
  },
  PRIVACY_MODAL_BEHAVIORAL_ADVERTISING_ENABLED_CLICKED: {
    name: 'Privacy Modal Behavioral Advertising Enabled',
    clickActivity: 'dotcom:privacymodal:behavioraladvertising:enable',
  },
  PRIVACY_MODAL_BEHAVIORAL_ADVERTISING_DISABLED_CLICKED: {
    name: 'Privacy Modal Behavioral Advertising Disabled',
    clickActivity: 'dotcom:privacymodal:behavioraladvertising:disable',
  },
  PRIVACY_MODAL_PERFORMANCE_AND_ANALYTICS_ENABLED_CLICKED: {
    name: 'Privacy Modal Performance And Analytics Enabled',
    clickActivity: 'dotcom:privacymodal:performanceandanalytics:enable',
  },
  PRIVACY_MODAL_PERFORMANCE_AND_ANALYTICS_DISABLED_CLICKED: {
    name: 'Privacy Modal Performance And Analytics Disabled',
    clickActivity: 'dotcom:privacymodal:performanceandanalytics:disable',
  },
};

/**
 * The specific value of the client side Host Name.
 */
export const HOST_NAME = process.env.HOST_NAME;

/**
 * The Inline Cookie component endpoint.
 */
export const INLINE_COOKIE_ENDPOINT = `https://${HOST_NAME}/fragments/inline-cookie`;

/**
 * The Inline Cookie staging component endpoint.
 */
export const INLINE_COOKIE_STAGING_ENDPOINT = `${INLINE_COOKIE_ENDPOINT}?nikeEnv=staging`;

/**
 * Cookie dialog class name.
 */
export const COOKIE_DIALOG_BASE_CLASS_NAME = 'cookie-dialog-base';
